var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62496 10.4342C1.83324 10.226 2.17093 10.226 2.37921 10.4342L4.64295 12.698L6.90669 10.4342C7.11497 10.226 7.45266 10.226 7.66094 10.4342C7.86922 10.6425 7.86922 10.9802 7.66094 11.1885L5.02007 13.8294C4.81179 14.0376 4.47411 14.0376 4.26583 13.8294L1.62496 11.1885C1.41668 10.9802 1.41668 10.6425 1.62496 10.4342Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6429 3.01564C4.93746 3.01564 5.17624 3.25442 5.17624 3.54897L5.17624 13.4522C5.17624 13.7468 4.93746 13.9856 4.6429 13.9856C4.34835 13.9856 4.10957 13.7468 4.10957 13.4522L4.10957 3.54897C4.10957 3.25442 4.34835 3.01564 4.6429 3.01564Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3792 6.56695C14.1709 6.77523 13.8332 6.77523 13.6249 6.56695L11.3612 4.3032L9.09745 6.56695C8.88917 6.77523 8.55149 6.77523 8.34321 6.56695C8.13493 6.35867 8.13493 6.02098 8.34321 5.8127L10.9841 3.17183C11.1924 2.96356 11.53 2.96356 11.7383 3.17183L14.3792 5.8127C14.5875 6.02098 14.5875 6.35867 14.3792 6.56695Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3612 13.9855C11.0667 13.9855 10.8279 13.7468 10.8279 13.4522L10.8279 3.54896C10.8279 3.25441 11.0667 3.01563 11.3612 3.01563C11.6558 3.01563 11.8946 3.25441 11.8946 3.54896L11.8946 13.4522C11.8946 13.7468 11.6558 13.9855 11.3612 13.9855Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.847c3909dd228741a0d166f6fa689876.svg";
export { ForwardRef as ReactComponent };